import { Component, Input, OnInit } from '@angular/core';
import { DriveFile } from '@freelancer/datastore';
import { VerticalAlignment } from '@freelancer/ui/grid';
import {
  HeadingSize,
  HeadingType,
  HeadingWeight,
} from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { DriveFileTypeApi } from 'api-typings/drive/drive';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-project-files-preview-modal',
  template: `
    <fl-heading
      *ngIf="(currentFile$ | async) as file"
      [headingType]="HeadingType.H1"
      [weight]="HeadingWeight.NORMAL"
      [size]="HeadingSize.SMALL"
      [flMarginBottom]="Margin.SMALL"
    >
      {{ file.displayName }}
    </fl-heading>
    <fl-drive-file-preview
      [file]="currentFile$ | async"
    ></fl-drive-file-preview>
    <fl-bit flTrackingSection="ImagePreview">
      <fl-grid [vAlign]="VerticalAlignment.VERTICAL_CENTER">
        <fl-col class="FooterNavigationContainer" [col]="4" [pull]="'right'">
          <app-project-files-preview-navigation
            flTrackingSection="ProjectFilePreviewModal"
            *ngIf="(files$ | async) && (files$ | async)?.length > 1"
            [initial]="index$ | async"
            [count]="fileCount$ | async"
            (navigate)="index$.next($event)"
          ></app-project-files-preview-navigation>
        </fl-col>
        <fl-col [col]="4" class="FooterDownloadContaier">
          <fl-drive-file-download
            *ngIf="(showDownloadButton$ | async)"
            [driveFileId]="(currentFile$ | async)?.id"
          ></fl-drive-file-download>
        </fl-col>
      </fl-grid>
    </fl-bit>
  `,
  styleUrls: ['./project-files-preview-modal.component.scss'],
})
export class ProjectFilesPreviewModalComponent implements OnInit {
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;
  HeadingWeight = HeadingWeight;
  Margin = Margin;
  VerticalAlignment = VerticalAlignment;

  @Input() files$: Rx.Observable<ReadonlyArray<DriveFile>>;
  @Input() index: number;

  index$: Rx.Subject<number>;
  currentFile$: Rx.Observable<DriveFile>;
  fileCount$: Rx.Observable<number>;
  showDownloadButton$: Rx.Observable<boolean>;

  ngOnInit() {
    this.index$ = new Rx.BehaviorSubject<number>(this.index);
    this.fileCount$ = this.files$.pipe(map(files => files.length));
    this.currentFile$ = Rx.combineLatest(this.files$, this.index$).pipe(
      map(([files, index]) => files[index]),
    );

    this.showDownloadButton$ = this.currentFile$.pipe(
      map(
        driveFile =>
          driveFile.fileType === DriveFileTypeApi.IMAGE ||
          driveFile.fileType === DriveFileTypeApi.VIDEO,
      ),
    );
  }
}
